// extracted by mini-css-extract-plugin
export default {"header":"DetailHeader_header__SmDIT","closeIcon":"DetailHeader_closeIcon__EEqnr"};